import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpacer = styled.div.withConfig({
  displayName: "Spacer__StyledSpacer",
  componentId: "mpx3hh-0"
})(props => {
  const theme = props.theme;
  const {
    $space,
    display
  } = props;
  return {
    boxSizing: 'border-box',
    display,
    blockSize: display === 'block' ? theme.space[$space] : undefined,
    inlineSize: display === 'inline-block' ? theme.space[$space] : undefined
  };
});
export const Spacer = ({
  display = 'block',
  space = '400'
}) => {
  const as = display === 'inline-block' ? 'span' : undefined;
  return /*#__PURE__*/_jsx(StyledSpacer, {
    as: as,
    display: display,
    $space: space
  });
};